import CopyToClipboard from './CopyToClipboard';

export default CopyToClipboard;

export * from './CopyText';
